// extracted by mini-css-extract-plugin
export default {"input":"DescriptionInput_input__cfvRu","fullWidth":"DescriptionInput_fullWidth__3c7nq"};